/**Accepts tints from .tintTopRight result, and will return a hex value
 * of that same tint
 * @param {Integer} Tint 
 */
export function TintReturn(Tint)
{
    var TintConverted;
    var Assembly = "0x";

    TintConverted = intBgrToIntRgb(Tint);
    TintConverted = Phaser.Display.Color.IntegerToColor(TintConverted);
    Assembly += Phaser.Display.Color.ComponentToHex(TintConverted.r);
    Assembly += Phaser.Display.Color.ComponentToHex(TintConverted.g);
    Assembly += Phaser.Display.Color.ComponentToHex(TintConverted.b);

    return Tint
    //return Assembly;
}

export function intBgrToIntRgb(num)
{
    let rgb = intBgrToRgb(num);

    let rgbInt = rgb.r;
    rgbInt = (rgbInt << 8) + rgb.g;
    rgbInt = (rgbInt << 8) + rgb.b;

    return rgbInt;
}

export function intBgrToRgb(num)
{
    return { r: num & 255, g: (num >> 8) & 255, b: (num >> 16) & 255 };
}

